/**
 * Fix Convercy/Bucks Currency Converter threshold bug
 *
 * O Convercy tem um bug onde preços acima de R$ 250 (25000 centavos)
 * não são divididos por 100 antes da conversão, resultando em preços
 * multiplicados por 100x.
 *
 * Este script corrige o bug interceptando o Convercy depois que ele
 * processa os preços e corrigindo os valores incorretos.
 */

(function() {
  'use strict';

  const THRESHOLD = 25000; // R$ 250.00 em centavos
  const CONVERCY_SELECTOR = 'cvc-money[data-cvc-value]';

  function fixConvercyPrices() {
    const cvcElements = document.querySelectorAll(CONVERCY_SELECTOR);

    cvcElements.forEach(el => {
      const cvcValue = parseFloat(el.getAttribute('data-cvc-value'));

      // Se o valor é maior que o threshold, está incorreto
      if (cvcValue > THRESHOLD) {
        // Verifica se tem o atributo data-currency-brl no pai
        const parentSpan = el.closest('span[data-currency-brl]');
        if (parentSpan) {
          const correctValue = parseFloat(parentSpan.getAttribute('data-currency-brl'));

          // Atualiza o data-cvc-value com o valor correto
          el.setAttribute('data-cvc-value', correctValue);

          console.log(`[Convercy Fix] Corrigido: ${cvcValue} → ${correctValue}`);

          // Remove as classes do Convercy para forçar re-processamento
          const parentCvcMoney = el.closest('.cvc-money');
          if (parentCvcMoney) {
            parentCvcMoney.classList.remove('cvc-money-done');
          }

          // Força o Convercy a re-processar chamando a função global se existir
          if (window.CVC && typeof window.CVC.convert === 'function') {
            window.CVC.convert();
          } else if (window.Bucks && typeof window.Bucks.convert === 'function') {
            window.Bucks.convert();
          }
        }
      }
    });
  }

  // Executa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixConvercyPrices);
  } else {
    fixConvercyPrices();
  }

  // Observa mudanças no DOM para pegar produtos carregados dinamicamente
  const observer = new MutationObserver((mutations) => {
    let shouldFix = false;

    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (
          node.querySelector && node.querySelector(CONVERCY_SELECTOR) ||
          node.matches && node.matches(CONVERCY_SELECTOR)
        )) {
          shouldFix = true;
        }
      });
    });

    if (shouldFix) {
      setTimeout(fixConvercyPrices, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Re-executa após o Convercy processar
  window.addEventListener('load', () => {
    setTimeout(fixConvercyPrices, 500);
  });

})();
